export default __webpack_public_path__ + "static/media/level_ups_page_framed.46902ded.png";